import { useCallback } from "react"

import { useLocation, useMatch, useNavigate } from "react-router-dom"

import { DescriptionIcon } from "@l2r-front/l2r-icons"
import { useMapDispatchContext } from "@l2r-front/l2r-map"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { API_MODULE_DOCUMENT, APP_DOCUMENT, MODULE_DOCUMENTS } from "../../constants/modules"

import * as Styled from "./DocumentModuleButton.styled"

export const DocumentModuleButton = () => {
    const { selectedNetwork } = useNetworksStateContext()
    const { storeMapBoundingBox } = useMapDispatchContext()

    const navigate = useNavigate()
    const match = useMatch("/:selectedNetwork/:app/:module/*")
    const location = useLocation

    const handleClick = useCallback(() => {
        const previousPath = match?.params?.["*"].length ? match?.params?.["*"] : ""
        const fullPath = `/${selectedNetwork.slug}/${APP_DOCUMENT}/${MODULE_DOCUMENTS}/${previousPath}${location?.search ? location.search : ""}`
        storeMapBoundingBox()
        navigate(fullPath)
    }, [selectedNetwork, match, location, navigate, storeMapBoundingBox])

    if (!selectedNetwork?.modules?.includes(API_MODULE_DOCUMENT)) {
        return null
    }

    return <Styled.Button onClick={handleClick}>
        <DescriptionIcon />
    </Styled.Button>
}